import { useEffect, useState } from 'react';
import { organisationsAPI } from '../api/organisationsAPI';

/**
 * Whether GET /api/organisations/me says the user may open the staff
 * dashboard: a platform admin, or active staff of an active organisation,
 * the same rule the server applies. Global user_type or role do not count.
 *
 * Only decides whether to offer the link; the dashboard itself is refused
 * by the server to anyone else. False until /me answers, and false if it
 * fails, so the link is never offered on a guess.
 */
export function canUseStaffDashboard(me) {
  if (me?.is_platform_admin === true) return true;
  const membership = me?.membership;
  return membership?.role === 'staff'
    && membership.status === 'active'
    && membership.organisation?.is_active === true;
}

const useStaffDashboardAccess = (userId) => {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    setAllowed(false);
    if (!userId) return undefined;
    let cancelled = false;
    organisationsAPI.me()
      .then((me) => { if (!cancelled) setAllowed(canUseStaffDashboard(me)); })
      .catch(() => { if (!cancelled) setAllowed(false); });
    return () => { cancelled = true; };
  }, [userId]);

  return allowed;
};

export default useStaffDashboardAccess;
